import BaseComponent from "../../../js/base-component";

class Search extends BaseComponent {

    constructor(options) {
        super(options);

        let box = document.querySelector(".u-search"),
            searchfield = document.querySelector(".u-search__field"),

        //methods
        setup = function () {
            searchfield.addEventListener("input", ajaxsearch);
        },
        ajaxsearch = function(evt) {
            // evt.preventDefault();

            if (evt.target.value.length > 2) {
                fetch(`/api/ajax/search?pattern=${evt.target.value}`)
                    .then(response => response.json())
                    .then(results => showResults(results))
                    .catch(error => console.log('error', error));
            }
        },
        showResults = function(results) {
            let resultsContainer = document.querySelector('.u-search__results');
            let resultsObj = {};

            if (typeof results.success !== 'undefined' && results.success === true) {
                let jsonData = results.data;

                resultsObj = '<ul class="u-search__results-list">';

                if (jsonData.results > 0) {
                    if (jsonData.items.length) {
                        jsonData.items.forEach((item) => {
                            resultsObj += `<li class="u-search-result__entry u-search-result__item">
                                    <a class="u-search-result__link" href="${item.link.href}" title="${item.link.text}" target="${item.link.target}">
                                        <span class="u-search-result__media">
                                            ${item.image}
                                        </span>
                                        <span class="u-search-result__name">${item.name}</span>
                                    </a></li>`
                        });
                    }
                    resultsObj += `<li class="u-search-results-all u-search__result__item">`;

                    if (jsonData.linkAll) {
                        resultsObj += `<a href="${jsonData.linkAll.href}" target="${jsonData.linkAll.target}" class="u-search-result__link u-search-results-all__link">
                        ${jsonData.linkAll.text}
                        <i class="seeger-icon--arrow-right"></i></a>`;
                    }

                    resultsObj += `<span class="u-search-results-all__number">${jsonData.results} Treffer</span></li>`;

                } else {

                    resultsObj += `<li class="u-search-result__entry u-search-result__entry--no-results u-search-result__item">Keine Suchergebnisse gefunden</li>`;
                }

                resultsObj += '</ul>';

                resultsContainer.innerHTML = resultsObj;

                resultsContainer.classList.add('is--active');
            }
        };

        if (box) {
            setup();
        }
    }
}

export default {
    definition: Search,
    name: "Search",
};
